module.exports = __webpack_public_path__ + "img/icon-shared.a8499b42.svg";